import { render } from "./CheckoutPayment.vue?vue&type=template&id=b5f40e9c"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__